import PropTypes from 'prop-types';
import React from 'react';
import CtaToFab from '../cta-to-fab';
import CreatePostHandler from '../../containers/create-post-handler';
import CreatePostCard from '../create-post-card';
import FloatingActionButton from '../floating-action-button';
import FloatingCreateButton from '../floating-create-button';
import ensureAuth from '../../hoc/ensure-auth';

const MOBILE_SCROLL_OFFSET = 50;

const CreatePostCardSecure = ensureAuth(CreatePostCard);
const FloatingCreateButtonSecure = ensureAuth(FloatingCreateButton);

const CreatePostCta = ({ categorySlug }) => {
  const cta = (
    <CreatePostHandler categorySlug={categorySlug}>
      <CreatePostCardSecure/>
    </CreatePostHandler>
  );
  const floatingButton = (
    <CreatePostHandler categorySlug={categorySlug}>
      <FloatingCreateButtonSecure/>
    </CreatePostHandler>
  );

  return (
    <CtaToFab cta={cta} fab={<FloatingActionButton button={floatingButton}/>} scrollOffset={MOBILE_SCROLL_OFFSET}/>
  );
};

CreatePostCta.propTypes = {
  categorySlug: PropTypes.string.isRequired,
};

export default CreatePostCta;



// WEBPACK FOOTER //
// ./app/components/create-post-cta/create-post-cta.js